import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useGenericDrawer } from "../../../hooks/drawer/useGenericDrawer";
import { IdentityMelcoModelsProductListItem } from "melco-shared-logic";
import { EditProductForm } from "../form/EditProductForm";

type EditProductDrawerProps = {
  isDrawerOpen: boolean;
  setDrawerOpen: (isDrawerOpen: boolean) => void;
  productDetails: IdentityMelcoModelsProductListItem;
};

export const EditProductDrawer: React.FC<EditProductDrawerProps> = ({
  isDrawerOpen,
  setDrawerOpen,
  productDetails,
}) => {
  const { t } = useTranslation();

  const referenceDrawer = useGenericDrawer();

  return (
    <Drawer
      title={t("products_list.edit.drawer.title")}
      placement="right"
      width={700}
      closable={true}
      onClose={() => setDrawerOpen(false)}
      open={isDrawerOpen}
      bodyStyle={{ padding: "32px" }}
    >
      <EditProductForm
        referenceDrawer={referenceDrawer}
        onCloseDrawer={setDrawerOpen}
        ProductDetails={productDetails}
      />
    </Drawer>
  );
};
